import React, { useState } from "react";
import { Card, Form, Button, Badge } from "react-bootstrap";

/* YOUR FUNCTION */
function generatePasswordsByCondition(input, options = {}) {
  const {
    onlyMeaningful = false,
    withSpace = false,
    limit = Infinity,
    dictionary = []
  } = options;

  const results = new Set();

  function isMeaningful(word) {
    return dictionary.includes(word);
  }

  function buildSentence(word, path = []) {
    if (word.length === 0) {
      results.add(path.join(" "));
      return;
    }

    for (let i = 1; i <= word.length; i++) {
      const part = word.slice(0, i);

      if (!onlyMeaningful || isMeaningful(part)) {
        buildSentence(word.slice(i), [...path, part]);
        if (results.size >= limit) return;
      }
    }
  }

  function permute(chars, current) {
    if (chars.length === 0) {
      if (withSpace) {
        buildSentence(current);
      } else {
        if (!onlyMeaningful || isMeaningful(current)) {
          results.add(current);
        }
      }
      return;
    }

    for (let i = 0; i < chars.length; i++) {
      permute(
        chars.slice(0, i).concat(chars.slice(i + 1)),
        current + chars[i]
      );
      if (results.size >= limit) return;
    }
  }

  permute(input.split(""), "");
  return Array.from(results).slice(0, limit);
}

/* UI COMPONENT */
const PasswordCombination = ({isDark}) => {
  const [input, setInput] = useState("");
  const [withSpace, setWithSpace] = useState(false);
  const [onlyMeaningful, setOnlyMeaningful] = useState(false);
  const [limit, setLimit] = useState(50);
  const [copied, setCopied] = useState("");

  const dictionary = ["hello", "hell", "low", "cat", "dog"]; // example

  const results =
    input.length > 0
      ? generatePasswordsByCondition(input, {
          withSpace,
          onlyMeaningful,
          limit,
          dictionary
        })
      : [];

  const copy = (text) => {
    navigator.clipboard.writeText(text);
    setCopied(text);
    setTimeout(() => setCopied(""), 800);
  };

  const copyAll = () => {
    navigator.clipboard.writeText(results.join("\n"));
  };

  return (
    <Card className={`pin-card shadow-sm border ${!isDark && "bg-light"}`}>
      <h4 className="text-center fw-bold mb-3">
        🔐 Password Combination Generator
      </h4>

      {/* Input */}
      <Form.Group className="mb-3">
        <Form.Label>Input</Form.Label>
        <Form.Control
          placeholder="Enter letters or numbers"
          value={input}
          onChange={(e) => setInput(e.target.value)}
        />
      </Form.Group>

      {/* Options */}
      <div className="d-flex gap-3 flex-wrap mb-3">
        <Form.Check
          label="Meaningful only"
          checked={onlyMeaningful}
          onChange={(e) => setOnlyMeaningful(e.target.checked)}
        />
        <Form.Check
          label="Allow spaces"
          checked={withSpace}
          onChange={(e) => setWithSpace(e.target.checked)}
        />
        <Form.Group style={{ maxWidth: 120 }}>
          <Form.Label>Limit</Form.Label>
          <Form.Control
            type="number"
            value={limit}
            onChange={(e) => setLimit(Number(e.target.value))}
          />
        </Form.Group>
      </div>

      {/* Actions */}
      <div className="d-flex justify-content-between align-items-center mb-2">
        <div>
          <b>Total:</b> {results.length}
        </div>
        <Button size="sm" variant="outline-primary" onClick={copyAll}>
          📋 Copy All
        </Button>
      </div>

      {/* Results */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fill, minmax(140px, 1fr))",
          gap: 10,
          maxHeight: 260,
          overflowY: "auto"
        }}
      >
        {results.map((item, i) => (
          <Badge
            key={i}
            bg={copied === item ? "success" : "light"}
            text={copied === item ? "light" : "dark"}
            onClick={() => copy(item)}
            style={{
              cursor: "pointer",
              padding: "12px",
              borderRadius: 12,
              border: "1px solid #ddd",
              textAlign: "center",
              fontSize: 13
            }}
          >
            {copied === item ? "Copied!" : item}
          </Badge>
        ))}
      </div>
    </Card>
  );
};

export default PasswordCombination;
